import { DeepReadonly } from '../declarations/deep-readonly';
import { PanelInfo } from '../declarations/ah-api';

export function isRaiz(panelInfo: DeepReadonly<PanelInfo> | null | undefined) {
  return panelInfo?.guid === '683a431d-87b3-424a-be72-aa29f2961f87' || panelInfo?.code?.toLowerCase() === 'raiz';
}

export function isSgag(panelInfo: DeepReadonly<PanelInfo> | null | undefined) {
  return panelInfo?.guid === 'edba6548-77bc-4c51-b84c-c3ea0db5afa4' || panelInfo?.code?.toLowerCase() === 'sgag';
}

export function isPpSg(panelInfo: DeepReadonly<PanelInfo> | null | undefined) {
  return panelInfo?.guid === 'c96ba4f3-c470-4e66-af7a-619355a88047' || panelInfo?.code?.toLowerCase() === 'pp-sg';
}

export function isAsianParents(panelInfo: DeepReadonly<PanelInfo> | null | undefined) {
  return (
    panelInfo?.guid === 'a3400e7d-6e3c-440b-beca-e7390807d2d7' || panelInfo?.code?.toLowerCase().startsWith('asprnt_')
  );
}

export function isYourSayPays(panelInfo: DeepReadonly<PanelInfo> | null | undefined) {
  return panelInfo?.guid === '751935bd-a830-4aba-93a1-56e0231b04b1' || panelInfo?.code?.toLowerCase().startsWith('ysp');
}

export function isSocialImpact(panelInfo: DeepReadonly<PanelInfo> | null | undefined) {
  return (
    panelInfo?.guid === '7f291798-0945-4b68-b24f-2f3625d145c7' ||
    panelInfo?.code?.toLowerCase().startsWith('socialimpact')
  );
}

export function isHorizonNZ(panelInfo: DeepReadonly<PanelInfo> | null | undefined) {
  return (
    panelInfo?.guid === '7c2407b9-34ba-4553-8844-401fee76d48e' ||
    panelInfo?.code?.toLowerCase().startsWith('horizon_nz')
  );
}

export function isHorizonMaori(panelInfo: DeepReadonly<PanelInfo> | null | undefined) {
  return (
    panelInfo?.guid === '7bb7b467-45ca-4bb1-b822-063725c48663' ||
    panelInfo?.code?.toLowerCase().startsWith('horizon_maori')
  );
}

export function isSprive(panelInfo: DeepReadonly<PanelInfo> | null | undefined) {
  return panelInfo?.code?.toLowerCase() === 'sprive' || panelInfo?.code?.toLowerCase() === 'sdk_snbx_sprive';
}
